import { withNamespaces } from "react-i18next";
import { Link } from "react-router-dom";
import { Badge, Card, CardBody, CardHeader, ListGroup, ListGroupItem } from "reactstrap";
import { TasksStatuses } from "src/modules/data-protection/constants";

const ComplianceTasks = ({ t, complianceQuery, assetId }) => {
    if (complianceQuery.isFetching) return null;

    const {
        platform
    } = complianceQuery.data?.data || {};

    return (
        <Card>
            <CardHeader>
                <h5 className="mb-0">
                    {t('Remediation Tasks')}
                </h5>
            </CardHeader>

            <CardBody className="p-0">
                <ListGroup flush>
                    {platform?.openTasks?.map(task => (
                        <ListGroupItem
                            key={task.taskId}
                            className="d-flex justify-content-between align-items-center"
                        >
                            <div className="d-flex align-items-center gap-2">
                                <i className="ri-task-line fs-5 text-primary" />

                                <Link
                                    to={`/admin/data-protection/softwares/${assetId}?tab=task-management&id=${task.taskId}`}
                                    className="link-body-emphasis text-decoration-none fw-medium"
                                >T{task.secondaryId}</Link>
                                <span>
                                    {task.name}
                                </span>
                            </div>

                            <Badge 
                                color="secondary"
                                style={{
                                    backgroundColor: `${TasksStatuses[task.status]?.color}`
                                }}
                            >
                                {t(TasksStatuses[task.status]?.title)}
                            </Badge>
                        </ListGroupItem>
                    ))}
                </ListGroup>
            </CardBody>
        </Card>
    )
}

export default withNamespaces()(
    ComplianceTasks
);